import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { TableBody, SearchActionBar } from '@insurancemenu/imenu-components-lib';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import TriggerRenewalsHeader from './TriggerRenewalsTableHeader';
import TriggerRenewalsBatchSection from './TriggerRenewalsBatchSection';
import TriggerRenewalsRow from './TriggerRenewalsRow';
import ManageEmailsModal from '../modals/ManageEmailsModal';
import WarningModals from '../modals/WarningModals';
import ManageExhibitsModal from '../modals/ManageExhibitsModal';
import ChangeEffectiveDateModal from '../modals/ChangeEffectiveDateModal';
import RemovePeriodModal from '../modals/RemovePeriodModal';
import MoveToRenewalModal from '../modals/MoveToRenewalModal';
import FiltersPanel from '../FiltersPannel';
import { TableStyled, TableWrapperStyled } from './styles';

const TriggerRenewalsContent: React.FC = observer(() => {
  const {
    paginationDelegate: { filters, page, totalPages, totalElements, setPage, setFilterValue },
    isLoading,
    renewalGroupDelegates,
    isInitialLoading,
    getRenewalGroupsPage,
    getAllAgencies,
  } = useTriggerRenewalsPageStore();

  const loading = isLoading || isInitialLoading;

  useEffect(() => {
    void getAllAgencies();
  }, []);

  useEffect(() => {
    void getRenewalGroupsPage();
  }, [
    filters.agencyId,
    filters.effectiveDate,
    filters.name,
    filters.stage,
    filters.exhibitsFilter,
    filters.ratesFilter,
    page,
  ]);

  const onChangePageNumber = (newNumber: number): void => {
    setPage(newNumber);
  };

  const onSearch = (value: string): void => {
    setFilterValue('name', value);
  };

  const onReset = (): void => {
    setFilterValue('name', '');
  };

  return (
    <>
      <FiltersPanel />
      <TableWrapperStyled>
        <SearchActionBar
          totalElements={totalElements}
          totalTitle="Total Groups Count"
          searchPlaceholder="Group Name"
          isSearchButtonDisabled={loading}
          onSearch={onSearch}
          onReset={onReset}
        />
        <TriggerRenewalsBatchSection />
        <TableStyled
          loading={loading}
          maxHeight="55rem"
          minHeight="55rem"
          totalElements={renewalGroupDelegates.length}
          pagination={{
            onPageChange: onChangePageNumber,
            maxPage: totalPages || 1,
            tablePage: page,
            showPageInput: true,
          }}
        >
          <TriggerRenewalsHeader />
          <TableBody>
            {renewalGroupDelegates.map((delegate) => {
              return <TriggerRenewalsRow groupDelegate={delegate} key={delegate.group.id} />;
            })}
          </TableBody>
        </TableStyled>
      </TableWrapperStyled>
      <ManageEmailsModal />
      <ManageExhibitsModal />
      <ChangeEffectiveDateModal />
      <RemovePeriodModal />
      <MoveToRenewalModal />
      <WarningModals />
    </>
  );
});

export default TriggerRenewalsContent;
